"use client";

import { captureError } from "@/utils/common.helpers";
import { reportRumError } from "@/lib/datadog-rum";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    reportRumError(error, { context: "global_error", digest: error.digest });
    captureError(error);

    // Send error details to Supabase for debugging
    const errorData = JSON.stringify({
      message: error.message,
      stack: error.stack,
      name: error.name,
      digest: error.digest,
      page_name: "GlobalErrorPage",
      url: typeof window !== "undefined" ? window.location.href : "",
      timestamp: new Date().toISOString(),
    });

    fetch("/api/send-to-supabase", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page_name: "global_error.tsx",
        pool_number: -1,
        user_id: crypto.randomUUID(),
        event_name: "error_page_viewed_debug",
        event_value: errorData,
      }),
    }).catch(console.error);
  }, [error]);

  return (
    <body>
      <NextError statusCode={undefined as any} />
    </body>
  );
}
